export default "__VITE_ASSET__e4a6d87d__"